@if (displayTimer() && timer()) {
	<span class="gtgt-timer">
		<span class="gtgt-timer-countdown" [style.color]="textColor()">
			@if (timer().days() > 0) {
				<span>{{ timer().days() | number: '2.0-0' }}days:</span>
			}
			@if (timer().days() > 0 || timer().hours() > 0) {
				<span>{{ timer().hours() | number: '2.0-0' }}hr:</span>
			}
			<span>{{ timer().minutes() | number: '2.0-0' }}min:{{ timer().seconds() | number: '2.0-0' }}s<!--econds --></span>
		</span>
	</span>
}